import React from 'react'
import TitleComponent from '../../../../global/Custom/TitleComponent/TitleComponent'

import { useTranslation } from 'react-i18next'
import BannerCategoryCreateScreen from './BannerProductCreateScreen'

function BannerProductCreate() {
  const {t} = useTranslation()

  return (
    <div>
        <TitleComponent title={t('Tạo mới banner sản phẩm')} isExist={false} />
        <BannerCategoryCreateScreen/>
    </div>
  )
}

export default BannerProductCreate
